import { render } from "./UploadDocumentFront.vue?vue&type=template&id=283a4104&ts=true"
import script from "./UploadDocumentFront.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentFront.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__